import React, { Fragment, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getDataByID, modularObj, orderList } from "../../functions";

const Sectional = (props) => {
    const { i18n, t } = useTranslation();
    // const [zeModels, setZeModels] = useState([])
    function clickProduct(model) {
        if (model.code === "modular") {
            props.iframe.setViewerModel(undefined, true);
        } else {
            props.iframe.setViewerModel(model.code)
        }
        props.select(model)
    }

    // useEffect(() => {
    //     let models = [];
    //     for (let m of props.collection.models) {
    //         const goodModel = getDataByID(props.db, "components", m);
    //         models.push(goodModel)
    //     }
    //     // console.log(models)
    //     models.sort((a, b) => orderList.indexOf(a.code) - orderList.indexOf(b.code));
    //     if (props.isBothMode) {
    //         models.unshift(modularObj)
    //     }
    //     setZeModels(models)
    // }, [])

    return (
        <ul>
            {props.allModels?.map((val, index) => {
                // const goodModel = getDataByID(props.db, "components", val);
                const goodIcon = val.code === "modular" ? 'images/thumbnails/modular.jpg' : `./images/thumbnails/${props.collection.code?.replace(/\s/g, "_")}/${val.code?.replace(/\s/g, "_")}.jpg`;
                return (
                    <Fragment key={index}>
                        {(val.type === "std" && !val.archived) &&
                            <li className={`h-[220px] max-h-[220px] ring-inset border-b border-black relative ${props.selectedIndex.id === val.id ? "ring-4 ring-black" : "hover:ring-2 hover:ring-gray-400"}`}>
                                <div className="my-auto">
                                    <img
                                        src={goodIcon}
                                        alt={val.code}
                                        className="my-auto p-4 w-full h-auto object-cover cursor-pointer"
                                        onClick={() => props.selectedIndex.id !== val.id && clickProduct(val)}
                                    />
                                </div>
                                {props.selectedIndex.id === val.id && <p className="lowercase font-NeueMTL absolute bottom-2 p-2 font-bold text-center left-1/2 -translate-x-1/2">{t("customWord", { fr: val.name.fr, en: val.name.en })}</p>}
                                {/* {props.selectedIndex === index && <div className='absolute w-full-plus-2 h-full-plus-2 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 ring-4 ring-black ring-inset z-10'></div>} */}
                            </li>}
                    </Fragment>
                )
            })}
        </ul>
    );
};

export default Sectional;
